/**
 * ProfileSync — tiny relay to break circular dependency between GodMode ↔ ComponentOverrides.
 * GodMode registers the real sync callback at init; ComponentOverrides calls it without importing GodMode.
 */

let _callback: (() => void) | null = null;

/** Called by GodMode to register the actual sync function */
export function registerProfileSyncCallback(fn: () => void): void {
  _callback = fn;
}

/** Called by any tuning module after a save to trigger profile sync */
export function notifyProfileChanged(): void {
  _callback?.();
}
